import React from 'react'
import Hauler from '../../components/page-content/our-apps/hauler'

export const Page = () => {
  return <Hauler />
}
export default Page
